export default {
  SET_ACTIVE: 'setActive',
  SET_TYPE: 'setType',
  SELECT_ID: 'selectId',
  DESELECT_ID: 'deselectId',
  SET_SELECTED_IDS: 'setSelectedIds',
};
